import fb from '../../firebase';

export const SignInService = (data) => fb.doSignIn(data)
export const SignOutService = () => fb.doSignOut();




